import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { Row, Col } from 'antd';
import BillModelData from '../ModelData';
import Item from 'antd/lib/list/Item';

const { TransportModeCode } = BillModelData;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const documentInfo = this.modulesState.receiptAdviceForm;
        return (
            <div>
                <Row>
                    
                    <Col span={5}>
                        <span className={css.titleName}>{this.ReceivedTimeName()}</span>
                    </Col>
                    <Col span={19}>
                        <div className={css.info}>{documentInfo.ActualDespatchDate && Field.formatTime(documentInfo.ActualDespatchDate)}</div>
                    </Col>
                </Row>
                <Row>
                    <Col span={5}>
                        <span className={css.titleName}>{this.ReceivedPlaceName()}</span>
                    </Col>
                    <Col span={19}>
                        <div className={css.info}>
                            {documentInfo.DespatchAddressLine}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
    /**
     * 获取 对应不同子类型名称
     */
    private ReceivedTimeName = () => {
        if (this.modulesState.billType === "ReceiptAdviceReturn") {
            return "退货时间";
        } else if (this.modulesState.billType === "ReceiptAdviceRATC01") {
            return "冲销时间";
        } else {
            return "收货时间";
        }
    }
    /**
     * 获取 对应不同子类型名称
     */
    private ReceivedPlaceName = () => {
        if (this.modulesState.billType === "ReceiptAdviceReturn") {
            return "货物存放地";
        } else if (this.modulesState.billType === "ReceiptAdviceRATC01") {
            return "货物存放地";
        } else {
            return "收货地";
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.ReceiptAdviceAddition.tsx